import {Component, input, OnInit} from '@angular/core';
import {TemplateDTO} from "../../common/model/template-dto.model";

@Component({
  selector: 'app-rubrica-item',
  templateUrl: './rubrica-item.component.html',
  styleUrls: ['./rubrica-item.component.scss']
})
export class RubricaItemComponent  implements OnInit {

  skeleton = input<boolean>();
  type = input<'vertical' | 'horizontal'>('vertical');
  fullWidth = input<boolean>();
  template = input<TemplateDTO>();

  constructor() { }

  ngOnInit() {
  }

}
